import { Primary, Secondary } from '@cinch-labs/design-system'

export interface CtaButtonProps {
  label: string
  url: string
  type?: 'primary' | 'secondary'
}

export const CtaButton = ({ label, url, type }: CtaButtonProps) =>
  type === 'primary' ? (
    <Primary element="a" href={url} isFullWidth>
      {label}
    </Primary>
  ) : (
    <Secondary element="a" href={url} isFullWidth>
      {label}
    </Secondary>
  )
